<template>
    <section class="small-left">
        <div class="spacing center gray">

            <lottie :name="'chapter-2/diagram-4-agnostic-voice'" :width="500" :height="604" />

        </div>
        <div class="spacing space-between">

            <div>

                <h2>Access agnostic voice services</h2>
                <h3>Consolidate all your services, fixed, mobile, hybrid and enterprise, on the new core</h3>

                <p>The 5G core with IMS-based voice services offers unified registration, authentication, session, mobility and policy management for all access types. In addition, common interfaces for 3GPP and non-3GPP accesses enable seamless mobility. New, tailored voice services can be deployed on dedicated network slices.</p>

            </div>

            <infobutton>
                The combination of these features unlocks significant value by enabling you to cost-effectively deploy services at scale for new applications and verticals. You can implement separate 5G network slices for fixed-only, mobile-only and converged services.
            </infobutton>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>